import { ComponentType, ElementType } from 'react';

import { useTenant } from '@packlink/tenant-provider';
import { TenantName } from '@packlink/packlink-sdk';
import { useTenantConfig } from '@packlink/tenant-config-provider';
import { GetHelpCenterPage, useHelpCenter } from '@packlink/provider';

import { SendAmplitude, useAmplitude } from '@metrics';

// TODO: https://auctane.atlassian.net/browse/IDE-587
export type WithTenant = {
    sendAmplitudeEvent: SendAmplitude;
    getSupportPage: GetHelpCenterPage;
    source: ITenantConfig['source'];
    secondHand: ITenantConfig['secondHand'];
    behaviour: ITenantConfig['behaviour'];
    tenantName: TenantName;
};

export function withTenant<P>(Component: ComponentType<P>): ElementType<Omit<P, keyof WithTenant>> {
    return function WithTenantProps(props: P): JSX.Element {
        const getSupportPage = useHelpCenter();
        const sendAmplitudeEvent = useAmplitude();
        const { name: tenantName } = useTenant();
        const { source, secondHand, behaviour } = useTenantConfig<ITenantConfig>();

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newProps: any = {
            ...props,
            sendAmplitudeEvent,
            getSupportPage,
            source,
            secondHand,
            tenantName,
            behaviour,
        };

        return <Component {...newProps} />;
    } as ElementType<Omit<P, keyof WithTenant>>;
}

// TODO: https://packlink.atlassian.net/browse/IDE-93
export const getBrandFromHostname = (brand: string): boolean => window.location.hostname.includes(brand.toLowerCase());
